<template>
	<div class="nobox">
		<div class="block-title">充电费用</div>
		<div ref="echartDiv" class="" style="height: 260px; width: 100%"></div>
	</div>
</template>
<script>
	import * as echarts from 'echarts';
	import {
		nextTick
	} from 'vue';

	function inityAxis(name) {
		return {
			type: 'value',
			name,
			spiltNumber: 10,
			splitLine: {
				show: true,
				lineStyle: {
					// 网格风格
					color: 'rgba(205,215,255,0.1)',
					width: 1, // 这里是为了突出显示加上的，可以去掉
					// type: 'dashed',
				},
			},
			axisLine: {
				show: true,
				lineStyle: {
					color: 'rgba(205,215,255,0.5)',
					width: 0,
				},
			},
			axisLabel: {
				show: true,
				color: 'rgba(255,255,255,0.6)',
			},
		};
	}

	let chartOption = {
		color: ['#BDF090', '#4DCEF8', '#BBBBBB', '#FF9F7F'],
		tooltip: {
			trigger: 'axis',
			axisPointer: {
				// 坐标轴指示器，坐标轴触发有效
				type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
			},
			backgroundColor: 'rgba(10, 50, 122, 0.75)',
			textStyle: {
				color: 'rgba(222,222,222,0.9)',
			},
		},
		legend: {
			data: ['总费用', '充电费', '服务费'],
			textStyle: {
				color: '#929ca8',
			},
		},
		grid: {
			left: 55,
			right: 40,
			top: 50,
			bottom: 35,
			// containLabel: true
			show: false,
		},
		xAxis: {
			type: 'category',
			name: '日期',
			data: [],
			splitLine: {
				show: true, // 显示网格
				lineStyle: {
					// 网格风格
					color: 'rgba(205,215,255,0.1)',
					// width: 1,//这里是为了突出显示加上的，可以去掉
					// type: 'dashed',
				},
			},
			nameTextStyle: {
				color: 'rgba(205,215,255,0.5)',
				verticalAlign: 'top',
				padding: [8, 0, 0, 0],
			},
			axisLine: {
				show: true,
				lineStyle: {
					color: 'rgba(205,215,255,0.1)',
					width: 1, // 这里是为了突出显示加上的，可以去掉
				},
			},
			axisLabel: {
				show: true,
				color: 'rgba(205,215,255,0.5)',
			},
		},
		yAxis: [
			inityAxis('费用(元)'),
			{
				type: 'value',
				name: '电量(度)',
				spiltNumber: 10,
				show: false,
				position: 'right',
				// min: -100000,
				// scale: true,
				splitLine: {
					show: true,
					lineStyle: {
						// 网格风格
						color: 'rgba(205,215,255,0.1)',
						width: 1, // 这里是为了突出显示加上的，可以去掉
						// type: 'dashed',
					},
				},
				axisLine: {
					show: true,
					onZero: false,
					lineStyle: {
						color: 'rgba(205,215,255,0.5)',
						width: 0,
					},
				},
				axisLabel: {
					show: true,
					color: 'rgba(255,255,255,0.6)',
				},
			},
			// {
			//    type: 'value',
			//    name: '费用(元)',
			//    color: 'white',
			// }
		],
		dataZoom: [{
			type: 'inside',
			start: 0,
			end: 100,
			handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
			handleSize: '80%',
			handleStyle: {
				color: '#fff',
				shadowBlur: 3,
				shadowColor: 'rgba(0, 0, 0, 0.6)',
				shadowOffsetX: 2,
				shadowOffsetY: 2,
			},
		}, ],
		series: [{
				name: '总费用',
				type: 'bar',
				data: [],
			},
			{
				name: '充电费',
				type: 'bar',
				stack: '费用',
				data: [],
			},
			{
				name: '服务费',
				type: 'bar',
				stack: '费用',
				data: [],
			},
			// {
			//   name: '充电电量',
			//   type: 'line',
			//   data: [],
			//   yAxisIndex: 1,
			// },
		],
	};

	export default {
		data() {
			return {
				costChart: null,
			}
		},
		mounted() {
			const chart = echarts.init(this.$refs.echartDiv);
			this.costChart = chart;
			// getData();
			// nextTick(() => {
			// 	this.costChart.resize();
			// });

			window.addEventListener('resize', () => this.costChart.resize());
		},
		methods: {
			setData(data) {
				chartOption.xAxis.data = data.TimePoints;
				chartOption.series[0].data = data.TotalFees;
				chartOption.series[1].data = data.ChargeFees;
				chartOption.series[2].data = data.ServiceFees;
				// chartOption.value.series[3].data = data.ChargeKwhs;
				// chartOption.value.yAxis[1].min = -Math.max(...data.TotalFees) / 1.2;
				this.costChart.setOption(chartOption);
			}
		}
	}
</script>
<style type="less" scoped>
@import '../style.css';
</style>